<span
  class="badge mw-100 overflow-hidden {{ sizingTheme()?.badgeClass }} {{ colorScheme()?.backgroundClass }}"
  [attr.title]="text() | translate"
>
  <span
    [ngClass]="{ 'sr-only': size() === 'micro' }"
    class="d-flex mw-100 align-items-center {{ sizingTheme()?.gapClass }} {{ colorScheme()?.textColorClass }} "
  >
    @if (iconClass()) {
      <i class="{{ iconClass() }} {{ colorScheme()?.iconColorClass }}" aria-hidden="true"></i>
    }
    @if (text()) {
      <span class="text-truncate d-flex align-items-center badge-line-height">
        <span class="lh-1">{{ text() | translate }}</span>
      </span>
    } @else {
      <ng-content />
    }
  </span>
</span>
